import { combineReducers } from 'redux';

// Front
import Layout from './layouts/reducer';

// Authentication
import Login from './auth/login/reducer';
import Account from './auth/register/reducer';
import ForgetPassword from './auth/forgetpwd/reducer';
import Profile from './auth/profile/reducer';

//Menu
import Menu from './menu/reducer';

//Menu
import TypeNotes from './typeNotes/reducer';

// Category Plans
import CategoryPlans from './categoryPlans/reducer';

// Associates
import Associates from './associates/reducer';

// Plans
import Plans from './plans/reducer';

// Category Organization
import CategoryOrganization from './categoryOrganization/reducer';

// Services
import Services from './services/reducer';

// Sellers
import Sellers from './sellers/reducer';

// Offices
import Offices from './offices/reducer';

// Cost Center
import CostCenter from './costCenter/reducer';

// Category Finance
import CategoryFinance from './categoryFinance/reducer';

// Proposal
import Proposal from './proposal/reducer';

// Kinship
import Kinship from './kinship/reducer';

// Organizations
import Organizations from './organizations/reducer';

// Notes Associates
import NotesAssociates from './notesAssociates/reducer';

// Units
import Units from './units/reducer';

// Specialties
import Specialties from './specialties/reducer';

// Provider Specialties
import ProviderSpecialty from './providerSpecialty/reducer';

// Users
import Users from './users/reducer';

// Credentials Network (NT)
import CredentialsNT from './credentialsNT/reducer';

// Schedule
import Schedule from './schedule/reducer';

// Upload Files
import Files from './uploadFiles/reducer';

// Overview
import Overview from './overview/reducer';

// Reports
import Reports from './reports/reducer';

// Accounts
import Accounts from './accounts/reducer';

// HistoryStatus
import HistoryStatus from './historyStatus/reducer';

// Supplies
import SuppliesList from './supplies/reducer';

// Bills to pay
import BillsToPay from './billsToPay/reducer';

// Validation Of Proposals
import ValidationOfProposals from './validationOfProposals/reducer';

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Menu,
  TypeNotes,
  CategoryPlans,
  Associates,
  Plans,
  CategoryOrganization,
  Services,
  Sellers,
  Offices,
  CostCenter,
  CategoryFinance,
  Proposal,
  Kinship,
  Organizations,
  NotesAssociates,
  Units,
  Specialties,
  Users,
  CredentialsNT,
  Files,
  Overview,
  Reports,
  ProviderSpecialty,
  Schedule,
  Accounts,
  HistoryStatus,
  SuppliesList,
  BillsToPay,
  ValidationOfProposals,
});

export default rootReducer;
